import React from 'react';
import { Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import useFeatureFlag, { FeatureFlag } from '../../../hooks/useFeatureFlag';
import { useCharbeePlanId } from '../../../hooks/usePrerenderUser';
import { CustomTooltip } from '~components/Tooltip';
import isCacheSettingsAllowedByPlan from '../utils/isCacheSettingsAllowedByPlan';
import { ChargeBeePlanId } from '@prerender/billing-shared';
import { useUpgradePlan } from '~features/UpgradePlan';

type CacheExpirationCellProps = {
  domain: string;
  disabled?: boolean;
};
function CacheExpirationCell({ domain, disabled }: CacheExpirationCellProps) {
  const chargebeePlanId = useCharbeePlanId();
  const { openUpgradePlan } = useUpgradePlan();

  const isDetailsPageAvailable = useFeatureFlag([FeatureFlag.DomainsDetails]);
  const isSchedulerSettingsAvailable = useFeatureFlag([FeatureFlag.DomainSchedulerSettings]);
  const detailsPagedAllowedByPlan = isCacheSettingsAllowedByPlan(chargebeePlanId);

  if (isDetailsPageAvailable || isSchedulerSettingsAvailable || detailsPagedAllowedByPlan)
    return (
      <CustomTooltip message="Set custom cache expiration rules per domain or URL" placement="top">
        <Link to={domain}>
          <Button type="link" disabled={disabled} style={{ textDecoration: disabled ? 'line-through' : 'none' }}>
            Details
          </Button>
        </Link>
      </CustomTooltip>
    );

  return (
    <CustomTooltip message="To set custom cache expiration rules per domain or URL, upgrade to Pro" placement="top">
      <Button
        type="default"
        variant="filled"
        color="blue"
        size="small"
        icon={<LockOutlined />}
        onClick={() =>
          openUpgradePlan('domainManager', ChargeBeePlanId.Pro, {
            ctaLocation: 'Domain List Page - Cache Expiration Link',
            ctaName: 'Upgrade',
          })
        }
      >
        Upgrade
      </Button>
    </CustomTooltip>
  );
}

export default React.memo(CacheExpirationCell);
